import './index.scss';

class Application {
    constructor() {
        this.scrollingDisabled = false;
        this.scrollingY = 0;
    }

    // Running

    run(func) {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', func);
        } else {
            func();
        }
    }

    // Scrolling: Global

    disableScrolling() {
        if (this.scrollingDisabled) { return; }

        const scrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = `-${scrollY}px`;
        document.body.style.width = '100%';

        this.scrollingDisabled = true;
        this.scrollingY = scrollY;
    }

    enableScrolling() {
        if (!this.scrollingDisabled) { return; }

        const scrollY = this.scrollingY;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);

        this.scrollingDisabled = false;
        this.scrollingY = 0;
    }

    getScrollY() {
        if (this.scrollingDisabled) {
            return this.scrollingY;
        } else {
            return window.scrollY;
        }
    }

    // Scrolling: Local

    scrollToHash(hash, smooth = true) {
        if (!hash) { return; }

        const node = document.querySelector(hash);
        if (!node) { return; }

        let y = node.getBoundingClientRect().top + window.scrollY;

        const header = document.querySelector('.site-header__bar');
        if (header) { y -= header.clientHeight; }

        window.scrollTo({
            top: y,
            left: 0,
            behavior: smooth ? 'smooth' : 'instant'
        });
    }
}

window.app = new Application();
